import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { setLogout } from "../redux/redux/global/action";
import axios from "../utils/axios";

const useLogout = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { instance } = useMsal();

  const handleLogout = async () => {
    console.log("handle logout");
    try {
      await axios.post("/authentication/logout");
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("accessData");
      localStorage.setItem("Type", "");
      dispatch(setLogout());
      history.push("/");
      sessionStorage.clear();
      instance.logoutRedirect();
    } catch (e) {
      console.error("Server logout error:", e);
    }
  };

  return handleLogout;
};

export default useLogout;
